import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { OnboardingService } from './onboarding.service';
import { inject } from '@angular/core';
import { ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, from, map, of, switchMap, take } from 'rxjs';
import { BsCacheService, BsHubService } from '@brightside-web/desktop/data-access/core-services';


// this guard should only block navigation if onboarding is NOT complete
// is this even necessary? onboarding guard should handle everything

export const onboardingCompleteGuard: CanActivateFn = (route, state) => {
  return checkOnboardingComplete();
};

export const onboardingMatchCompleteGuard: CanMatchFn = (route, segments) => {
  return checkOnboardingComplete();
}

export const onboardingCompleteCanActivateGuard: CanActivateFn = (route, state) => {
  return checkOnboardingComplete();
}

function checkOnboardingComplete() {
  const _onboardingService = inject(OnboardingService);
  const _bsHubService = inject(BsHubService);
  const _bsCacheService = inject(BsCacheService);
  const router = inject(Router);

  return toObservable(_onboardingService.state).pipe(
    filter((s): s is ServiceState => s !== null),
    take(1),
    switchMap(state => {
      return from(_bsCacheService.getItem('ONBOARDING_COMPLETE')).pipe(
        map(complete => {
          if (complete) {
            _bsCacheService.removeItem('ONBOARDING_FLOW_ACTIVE');
            _bsHubService.dispatch('OnboardingChannel', { event: 'OnboardingComplete', message: 'cleared guard' });
            return true;
          } else {
            if (state === ServiceState.INITIAL || state === ServiceState.PENDING) {
              return router.parseUrl('/onboarding');
            }
            _bsCacheService.removeItem('ONBOARDING_FLOW_ACTIVE');
            _bsHubService.dispatch('OnboardingChannel', { event: 'OnboardingComplete', message: 'cleared guard' });
            return true;
          }
        })
      )
    })
  );
}
